import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Home, Settings, Logout, Notifications } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import HttpsIcon from "@mui/icons-material/Https";

import CustomConfirmation from "../popUp/CustomConfirmation";
import { s3baseUri } from "../../config/config";
import FeedbackIcon from "@mui/icons-material/Feedback";
import {
  candidate_api_detail_fetch,
  client_detail_api,
} from "../../DAL/partner/partners";
import { useIds } from "../../hook/AdminContext";
import GeneralMuiModal from "./MenuModalMui";
import ChangePassword from "./ChangePassword";
import FeedBack from "./FeedBack";

export default function Accountmenu({ anchorEl, open, handleClose }) {
  const { profileNewImage, userInfo } = useIds();
  const navigate = useNavigate();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [profileImage, setProfileImage] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);

  const handleProfile = () => {
    navigate("/profile");
    handleClose();
  };
  const handlePAymentRequests = () => {
    navigate("/payment-requests");
    handleClose();
  };

  const handleDialogueOpen = () => {
    handleClose();
    setLogoutDialogOpen(true);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/login");
    enqueueSnackbar("Logout Successful.", { variant: "success" });
  };

  const navigateHome = () => {
    navigate("/home");
    handleClose();
  };

  return (
    <>
      <GeneralMuiModal
        open={dialogOpen}
        setOpen={setDialogOpen}
        title={"Change Password"}
        componentToPass={
          <ChangePassword
            handleClose={handleClose}
            setDialogOpen={setDialogOpen}
          />
        }
      />

      <FeedBack
        openFeedback={openFeedback}
        setOpenFeedback={setOpenFeedback}
        user={userInfo}
      />

      <CustomConfirmation
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        title="Are you sure you want to sign out?"
        handleAgree={handleLogout}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1.5,
            borderRadius: "10px",
            minWidth: "220px",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        <MenuItem>
          <>
            <Avatar src={s3baseUri + userInfo?.profile_image} sx={{ mr: 1 }} />
            <Box>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {userInfo?.type === 2
                  ? userInfo?.company_name
                  : `${userInfo?.first_name} ${userInfo?.last_name}`}
              </Typography>

              <Typography
                variant="body2"
                sx={{ fontSize: "12px", opacity: 0.8 }}
              >
                {userInfo?.user_id?.email}
              </Typography>
            </Box>
          </>
        </MenuItem>
        <Divider />
        <MenuItem onClick={navigateHome}>
          <ListItemIcon>
            <Home fontSize="small" style={{ color: "#daa520" }} />
          </ListItemIcon>
          Home
        </MenuItem>

        <MenuItem onClick={handleProfile}>
          <ListItemIcon>
            <Settings fontSize="small" style={{ color: "#daa520" }} />
          </ListItemIcon>
          Profile Settings
        </MenuItem>
        <MenuItem onClick={handlePAymentRequests}>
          <ListItemIcon>
            <AccountBalanceIcon fontSize="small" style={{ color: "#daa520" }} />
          </ListItemIcon>
          Payment Requests
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setDialogOpen(true);
          }}
        >
          <ListItemIcon>
            <HttpsIcon fontSize="small" style={{ color: "#daa520" }} />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setOpenFeedback(true);
          }}
        >
          <ListItemIcon>
            <FeedbackIcon fontSize="small" style={{ color: "#daa520" }} />
          </ListItemIcon>
          Feedback
        </MenuItem>
        <Divider />
        <MenuItem sx={{ color: "red" }} onClick={handleDialogueOpen}>
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: "red" }} />
          </ListItemIcon>
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
}
